<div class="row back-fotter">
    <div class="col-12 col-md-1 text-center">
        <div class="divider"></div>
        <img class="img-responsive px-2" src="../../../assets/images/logo_white.svg" />
    </div>
    <div class="col-12 col-md-8">
        <div class="divider"></div>
        <div class="row">
            <div class="col-md-3" *ngFor="let item of listViewFooter;let index">
                <div class="footer-color" *ngFor="let subitem of item.detail;let index">
                    <p *ngIf="subitem.item.length > 1">{{ subitem.item }}</p>
                    <p *ngIf="subitem.item.length == 1" style="color: #290620;">{{ subitem.item }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 col-md-3">
        <div class="divider"></div>
        <div class="row">
            <div class="col-auto px-0">
                <div class="guion" style="margin-top: 40px;"></div>
            </div>
            <div class="col-10" >
                <div class="footer-color">Contáctanos</div>
                <div class="footer-subcolor">Nuestro canal de atención por Whatsapp es manera más rápida de resolver tus dudas y está disponible las 24 horas.</div>
                <div class="row" style="margin-top: 20px;">
                    <div class="col-auto">
                        <img  src="../../../assets/images/icons/Vector.png" />
                    </div>
                    <div class="col-auto">
                        <button mat-button class="button butttonfooter" color="primary">
                            944944116
                        </button>
                    </div>
                </div>
                <div class="footer-color" style="margin-top: 40px;">Ingresar solicitud o reclamo</div>
                <div class="footer-color">Consultar estado de solicitud o reclamo</div>
            </div>
        </div>
    </div>
    <div class="divider"></div>
</div>